export default {
  computed: {
    internalValue: {
      get() {
        // the api will frequently come back with " ", we've been asked to convert these to ""
        // whenever possible
        if (typeof this.value === 'string' && this.value.trim().length === 0 && this.value.length > 0) {
          this.$emit('input', '')
        }

        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  methods: {
    emitInternalValue() {
      this.$emit('input', this.internalValue)
    }
  }
}
